import type { Keyword } from "./types";

export function createKeyword({
    term,
    volume,
    isSeed = false,
    isLoading = false,
    selected = false,
    isRecentlyAdded = false,
}: Keyword): Keyword {
    return {
        term,
        volume,
        isSeed,
        isLoading,
        selected,
        isRecentlyAdded,
    };
}
